import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";

const heroBanners = [
  {
    image: "/hero/hero_personal_training.png",
    
    alt: "Personal Training",
    title: "Personal Training",
    href: "/all-product?category=personal-training",
  },
  {
    image: "/hero/hero_nutrition.png",
    alt: "Nutrition Plans",
    title: "Nutrition Plans",
    href: "/all-product?category=nutrition",
  },
  {
    image: "/hero/hero_home_workout.png",
    alt: "Home Workouts",
    title: "Home Workouts",
    href: "/all-product?category=home-workouts",
  },
  {
    image: "/hero/hero_yoga.png",
    alt: "Yoga Classes",
    title: "Yoga Classes",
    href: "/all-product?category=yoga",
  },
  {
    image: "/hero/hero_home_workout.png",
    alt: "Weight Loss",
    title: "Weight Loss",
    href: "/all-product?category=weight-loss",
  },
  {
    image: "/hero/hero_personal_training.png",
    alt: "Strength Training",
    title: "Strength Training",
    href: "/all-product?category=strength",
  },
  {
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400",
    alt: "Cardio Programs",
    title: "Cardio Programs",
    href: "/all-product?category=cardio",
  },
  {
    image: "https://images.unsplash.com/photo-1570829460005-c840387bb1ca?w=1200",
    alt: "All Programs",
    title: "All Programs",
    href: "/all-product",
  },
];

export default function HeroBannerSwiper() {
  const swiperRef = useRef<SwiperType | null>(null);

  return (
    <section className="home-swiper-banner-section mb-8 w-full">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
        <h2 className="text-center text-lg font-semibold text-blue-600 mb-6">
          Explore Our Fitness Programs
        </h2>
        <div className="relative swiper-container-wrapper">
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            modules={[Navigation, Autoplay]}
            spaceBetween={15}
            slidesPerView={6}
            navigation={{
              nextEl: ".hero-swiper-button-next",
              prevEl: ".hero-swiper-button-prev",
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              300: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 6,
                spaceBetween: 20,
              },
            }}
            className="AkashHomeSwiperBanner"
          >
            {heroBanners.map((banner, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={banner.href}
                  className="home-banner-swiper block"
                  title={banner.title}
                >
                  <img
                    src={banner.image}
                    alt={banner.alt}
                    className="w-full h-full object-cover rounded-[10px] transition-transform duration-300 hover:scale-105"
                    loading={index < 6 ? "eager" : "lazy"}
                  />
                  <span className="font-semibold">{banner.title}</span>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="hero-swiper-button-next swiper-button-next"></div>
          <div className="hero-swiper-button-prev swiper-button-prev"></div>
        </div>
      </div>
    </section>
  );
}

